import { render } from "./BrandKit.vue?vue&type=template&id=cbdcba30&scoped=true"
import script from "./BrandKit.vue?vue&type=script&lang=js"
export * from "./BrandKit.vue?vue&type=script&lang=js"

import "./BrandKit.vue?vue&type=style&index=0&id=cbdcba30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdcba30"]])

export default __exports__